angular.module('cian.geoInput')
.directive('geoInput', function () {
  return {
    controller: 'GeoInputCtrl',
    controllerAs: 'geoInputCtrl',
    template: require('../../templates/geo-input.html'),
    restrict: 'EA'
  };
});



// WEBPACK FOOTER //
// ./src/components/geo-input/src/scripts/cian.geo-input.dir.js